import React from 'react';
import './portfolio.css';
import pizza from '../../assets/pizza.webp';
import notes from '../../assets/notes.webp'
import IMG2 from '../../assets/portfolio3.jpg'
import IMG3 from '../../assets/portfolio4.jpg'
import ONE from '../../assets/1.JPG';
import lp from '../../assets/lp.webp';

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>


      <div className="container portfolio__container">
        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={lp} alt="note"/>
          </div>
          <h3>Simple Landing Page</h3>
          <div  className='portfolio__item-cta'>
            <a href='https://github.com/Chitochuks/Landing-Page' className='btn' target='_blank'>Github</a>
            <a href='https://chitolandingpageproj.netlify.app/' className='btn btn-primary' target='_blank'>Live Demo</a>
          </div>
        </article>
        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={pizza} alt="pizz"/>
          </div>
          <h3>Cheetos Pizza</h3>
          <div  className='portfolio__item-cta'>
            <a href='https://github.com/Chitochuks/Cheetos-Pizza' className='btn' target='_blank'>Github</a>
            <a href='https://dribble.com/Alien_pixels' className='btn btn-primary' target='_blank'>Live Demo</a>
          </div>
        </article>
        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={ONE} alt=""/>
          </div>
          <h3>Skincare E-commerce app</h3>
          <div  className='portfolio__item-cta'>
            <a href='https://github.com/Chitochuks/skincare-ecommerce' className='btn' target='_blank'>Github</a>
            <a href='https://dribble.com/Alien_pixels' className='btn btn-primary' target='_blank'>Live Demo</a>
          </div>
        </article>

        {/* <div className='container portfolio_container'>
          {
            data.map(({id, image, title, Github, LiveDemo}) => {
              return (
                <article key={id} className='portfolio__item'>
                  <div className="portfolio__item-image">
                    <img src={image} alt={title}/>
                  </div>
                  <h3>{title}</h3>
                <div  className='portfolio__item-cta'>
                  <a href={github} className='btn' target='_blank'>Github</a>
                  <a href={LiveDemo} className='btn btn-primary' target='_blank'>Live Demo</a>
                </div>
                </article>
              )
            })
          }
        </div> */}
      </div>
    </section>
  )
}

export default Portfolio